import * as React from "react";
import { SGBSColor } from "../../common/common.typings";

export interface ModalContentProps {
  borderColor?: SGBSColor;
  children?: React.ReactNode[];
  className?: string;
}

// eslint-disable-next-line react/display-name
const ModalContent = React.forwardRef<HTMLDivElement, ModalContentProps>(
  ({ borderColor, children, className = "" }, ref) => {
    const borderClassName = borderColor ? `border border-${borderColor}` : "";
    return (
      <div
      className={`modal-content shadow-max ${borderClassName} ${className}`}
      ref={ref}
    >
      {children}
    </div>
    )
  }


);

export default ModalContent;
